<template>
  <nav :aria-label="i18n.general.breadcrumbs">
    <ul class="breadcrumb">
      <li
        v-for="(item, i) in breadcrumbItems"
        :key="i"
        class="breadcrumb-item"
      >
        <template v-if="i === 0">
          <a
            :href="item.href"
            :aria-label="homepageLabel"
            class="breadcrumb-link"
          >
            <IcomoonHome
              class="icon scale-90 text-primary-bravo"
              :title="homepageLabel"
            />
          </a>
        </template>

        <template v-else-if="i < breadcrumbItems.length - 1">
          <a
            class="breadcrumb-link"
            :href="item.href"
          >
            {{ item.label }}
          </a>
        </template>

        <template v-else>
          {{ item.label }}
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>

export default {
  name: 'KfBreadcrumb',
  components: {
    IcomoonHome: () => import(/* webpackChunkName: "main"*/ '@/components/svg/IcomoonHome.vue'),
  },
  props: {
    homepageLabel: {
      type: String,
      default: 'Homepage',
    },
    breadcrumbItems: {
      type: Array,
      default: null,
    },
    i18n: {
      type: Object,
      default: null,
    },
  },
  computed: {
    classes() {
      return {
        'is-centered': this.centered,
        'is-review': this.review,
      };
    },
  },
};
</script>

<style lang="postcss">
.breadcrumb {
  @apply relative hidden pt-20 pb-6 text-sm items-start;

  @screen md {
    @apply flex;
  }

  @screen xl {
    @apply pb-16;
  }

  &-item {
    @apply relative mr-2 pr-4;

    &::before {
      @apply absolute bg-no-repeat bg-contain right-0;
      width: 6px;
      height: 6px;
      top: 9px;
      content: '';
      background-image: url('~@/assets/svg/chevron-right.svg?inline');
    }

    &:first-of-type {
      .icon {
        @apply relative w-3 h-3;
        top: 4px;
      }
    }

    &:last-of-type {
      &::before {
        background-image: none;
      }
    }
  }

  &-link {
    text-decoration-color: theme('colors.black');
    @apply !block;


    &:hover {
      text-decoration: none;
    }

    &:focus {
      @apply outline-none ring-2 ring-black;
    }
  }

}
</style>






